<template>
  <!-- 无需模板内容 -->
  <div></div>
</template>

<script>
export default {
  name: 'HiddenIframe',
  props: ['url'],
  methods: {
    /**
     * 创建隐藏的 iframe
     * @param {string} url 目标地址
     * @param {number} [timeout=60000] 自动移除延迟（毫秒）
     */
    createHiddenIframe (url, timeout = 60000) {
      const ifr = document.createElement('iframe')
      ifr.src = url
      ifr.style.visibility = 'hidden'
      ifr.style.width = '0'
      ifr.style.height = '0'
      ifr.style.border = '0'
      ifr.style.position = 'absolute'
      ifr.style.left = '-9999px'

      document.body.appendChild(ifr)

      // 可选：若干秒后自动移除
      if (timeout > 0) {
        setTimeout(() => {
          if (document.body.contains(ifr)) {
            document.body.removeChild(ifr)
          }
        }, timeout)
      }

      return ifr // 可用于监听 load 等事件
    }
  },

  mounted () {
    // 组件挂载后立即创建
    this.createHiddenIframe(this.url)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HiddenIframe/index.vue